import { PayloadAction } from '@reduxjs/toolkit'

import {
  TikTokFollowWelcomeMessageState,
  TikTokFollowWelcomeSetupModalState,
  TikTokFollowWelcomeSetupStep,
} from 'apps/tiktokFollowWelcome/interfaces'
import { createModalSlice } from 'shared/lib/factory/redux/createModalSlice'

const initialState: TikTokFollowWelcomeSetupModalState = {
  isOpen: false,
  step: TikTokFollowWelcomeSetupStep.INTRO,
  message: null,
}

export const tiktokFollowWelcomeSetupModalSlice = createModalSlice({
  name: 'tiktokFollowWelcomeSetupModal',
  initialState,
  reducers: {
    openWithMessage: (state, action: PayloadAction<TikTokFollowWelcomeMessageState>) => {
      state.isOpen = true
      state.step = TikTokFollowWelcomeSetupStep.INTRO
      state.message = action.payload
    },
    setStep: (state, action: PayloadAction<TikTokFollowWelcomeSetupStep>) => {
      state.step = action.payload
    },
  },
})

export const tiktokFollowWelcomeSetupModalActions = tiktokFollowWelcomeSetupModalSlice.actions
